import type { InfiltrationStage, KeyboardLikeEvent } from "../InfiltrationStage";

export class IntroModel implements InfiltrationStage {
  onKey(__: KeyboardLikeEvent) {}
}
